<div>
  <!--p-toast class="bl-toast bl-toast--success" key="successMessageAfsReview" closable="true" [escape]="true">
    <ng-template let-message pTemplate="message">
      <span class="ui-toast-icon template-position">
        <i class="fas fa-check"></i>
      </span>
      <div class="ui-toast-message-text-content">
        <h3 class="ui-toast-summary">Success</h3>
        <span class="ui-toast-detail">Analysis completed.
          <a class="link-style">{{ templateSuccess.scoreTemplate }}</a>
          to see the results</span>
      </div>
    </ng-template>
  </p-toast-->
  <p-toast class="bl-toast bl-toast--success" key="successMessage" closable="true"></p-toast>
  <p-toast class="bl-toast bl-toast--error" key="errorMessage" closable="true"></p-toast>
  <br />
  <div *ngIf="!isMyActionPlan" class="col-md-5 col-sm-5 bl-afs-review__group-data-wrapper without-br">
    <span class="status-action-plan" [ngClass]="
               {
                 'skin-reject1' : operationNumber.status == 'Required',
                 'skin-reject2' : operationNumber.status == 'Remitted',
                 'skin-reject3' : operationNumber.status == 'In process',
                 'skin-reject4' : operationNumber.status == 'Not Completed',
                 'skin-reject5' : operationNumber.status == 'Pending Approve'
               }">Status: {{operationNumber.status}} </span>
  </div>
  <br />
  <div class="bl-table col-12">
    <mat-form-field class="search-text">
      <input matInput (keyup)="filtrar($event)" placeholder="Search">
    </mat-form-field>
    <!--mat-paginator [pageSizeOptions]="selectedPage" [pageSize]="pageSize" showFirstLastButtons
      class="pagination-component"></mat-paginator-->

    <button
      *ngIf="(rolUser.role == 'OEG') && (operationNumber.status == 'Required' || operationNumber.status == 'Reject' || operationNumber.status == 'Observed' || operationNumber.status == 'Not Completed')"
      class="bl-button--btn-finish bl-button--btn-finish--lg btn-delyvery" type="submit"
      (click)="showSubmit('Required')">
      Save
    </button>
    <button *ngIf="(rolUser.role == 'OEG') && operationNumber.status == 'In Process' "
      class="bl-button--btn-finish bl-button--btn-finish--lg btn-delyvery" type="submit"
      (click)="showSubmit('In Process')">
      Save
    </button>

    <button
      *ngIf="(rolUser.role == 'OEG' && isDataComplete) && (operationNumber.status == 'Required' || operationNumber.status == 'Reject')"
      class="bl-button--btn-secundary btn-delyvery" type="submit" (click)="sendNotify('Pending Approve')">
      Submit
    </button>

    <button *ngIf="(rolUser.role == 'OEA' && isDataComplete) && (operationNumber.status == 'Pending Approve')"
      class="bl-button--btn-reject bl-button--btn-finish--lg btn-delyvery" type="submit" (click)="sendNotify('Reject')">
      Reject
    </button>

    <button *ngIf="(rolUser.role == 'OEA' && isDataComplete) && (operationNumber.status == 'Pending Approve')"
      class="bl-button--btn-finish bl-button--btn-finish--lg btn-delyvery" type="submit"
      (click)="updateActionPlanApprove()">
      Approve
    </button>
    <button *ngIf="rolUser.role == 'Admin' && isMyActionPlan  && operationNumber.status == 'Remitted'"
      [disabled]="!operationNumber" class="bl-button--btn-reject bl-button--btn-finish--lg btn-delyvery" type="submit"
      (click)="SaveActionPlanFR()">
      Observed
    </button>
    <button *ngIf="rolUser.role == 'Admin'  && isMyActionPlan && operationNumber.status == 'Remitted'"
      [disabled]="disabledButton == false || !operationNumber"
      class="bl-button--btn-finish bl-button--btn-finish--lg btn-delyvery" type="submit" (click)="confirmFR()">
      Confirmed
    </button>
    <button *ngIf="rolUser.role == 'OEA' && isMyActionPlan" [disabled]="!operationNumber"
      class="bl-button--btn-seacher bl-button--btn-seacher--lg button--btn-finish--lg btn-export btn-delyvery"
      type="submit">
      <i class="far fa-file-pdf"></i> Export to pdf
    </button>

    <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" style="width: 100%"
      #tabla1>
      <ng-container matColumnDef="item_id">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 4%">Item</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <a class="tooltip top">{{ element.indexClone }}</a>
        </td>
      </ng-container>
      <ng-container matColumnDef="finding">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 8%">
          Finding
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div class="bl-textarea">
            <ng-container>
              <label></label>
              <textarea *ngIf="!element.clone"
                class="textarea__area-modal--size-small textarea__area-modal--color-table"
                disabled>{{ element.finding }}</textarea>
            </ng-container>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="recommendation">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 8%">
          Recommendation
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div class="bl-textarea">
            <ng-container>
              <label></label>
              <textarea *ngIf="!element.clone"
                class="textarea__area-modal--size-small textarea__area-modal--color-table"
                disabled>{{ element.recommendation }}</textarea>
            </ng-container>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="comments">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 10%">
          Comment IDB
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div class="bl-textarea">
            <ng-container>
              <label></label>
              <textarea *ngIf="!element.clone"
                class="textarea__area-modal--size-small textarea__area-modal--color-table"
                disabled>{{ element.commentsIDB }}</textarea>
            </ng-container>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="actionsDE">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 10%">
          Actions defined by the Executor
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div *ngIf="!activeSubmit" class="bl-textarea">
            <ng-container>

              <textarea
                [style.border]="element.definedActions=='' ? '0.0714285714rem solid red': '0.0714285714rem solid #cccccc;'"
                class="textarea__area-modal--size-small textarea__area-modal--color-table" style="width: 100%"
                [(ngModel)]="element.definedActions"
                [disabled]="rolUser.role == 'OEA' || isMyActionPlan || operationNumber.status == 'Remitted'"
                (ngModelChange)="validaIsNotify()">{{ element.definedActions }}</textarea>
            </ng-container>
            <br />
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="responsable">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 10%">
          Responsible
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div *ngIf="!activeSubmit" class="field-container">
            <div class="position-input">
              <input
                [style.border]="element.responsible=='' ? '0.0714285714rem solid red': '0.0714285714rem solid #cccccc;'"
                class="input__text--size-small input__text--color-table text-small" id="responsableTitle" type="text"
                pInputText [(ngModel)]="element.responsible"
                [disabled]="rolUser.role == 'OEA' || isMyActionPlan || operationNumber.status == 'Remitted'"
                (ngModelChange)="validaIsNotify()" />
            </div>
          </div>
          <div *ngIf="activeSubmit" class="field-container">
            <div class="position-input">
              <input class="input__text--size-small input__text--color-table" id="responsableTitle" type="text"
                pInputText [(ngModel)]="element.responsible" disabled />
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="estimatedID">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 7%">
          Estimated <br> implementation date
        </th>
        <td mat-cell *matCellDef="let element; let i = index" style="width: 4%">
          <div *ngIf="!activeSubmit" class="field-container">
            <div class="datepicker-formfield">
              <mat-form-field appearance="fill">
                <input class="date-datepicker space-date combobox" matInput [matDatepickerFilter]="myFilter"
                  [matDatepicker]="picker" (dateChange)=(dateChange(i,$event)) [(ngModel)]="element.endLimitTime"
                  [disabled]="rolUser.role == 'OEA' || isMyActionPlan || operationNumber.status == 'Remitted'"
                  [min]="minDate" [max]="maxDate" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

            </div>
          </div>
          <div *ngIf="activeSubmit" class="field-container">
            <div class="datepicker-formfield-disabled">
              <mat-form-field appearance="fill">
                <input [readonly]="true" class="date-datepicker space-date combobox" matInput
                  [matDatepickerFilter]="myFilter" [matDatepicker]="picker" />
                <mat-datepicker-toggle matSuffix [for]="picker" disabled></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="meansV">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 7%">
          Means of verification
        </th>
        <td mat-cell *matCellDef="let element; let i = index"  style="width: 10%">
          <div *ngIf="!activeSubmit" class="field-container">
            <div class="position-input">
              <input
                [style.border]="element.verificationMeans=='' ? '0.0714285714rem solid red': '0.0714285714rem solid #cccccc;'"
                class="input__text--size-small input__text--color-table text-small" id="verificationMeans" type="text"
                pInputText [(ngModel)]="element.verificationMeans"
                [disabled]="rolUser.role == 'OEA' || isMyActionPlan || operationNumber.status == 'Remitted'"
                (ngModelChange)="validaIsNotify()" />
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="statusI">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 7%">
          Status Implementation
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div *ngIf="!activeSubmit" class="field-container without-br">
            <div class="position-input">
              <input class="input__text--size-small input__text--color-table text-small" id="responsableTitle"
                type="text" pInputText [(ngModel)]="element.statusActionImplement" disabled />
              <span class="bl-historical-search__margin-icon-search" style=" margin-left: -45px;">
                <i *ngIf="element.statusActionImplement == 'Complete'" class="fas fa-check-circle"
                  style="color:rgb(50, 143, 10); position: relative;"></i>
                <i *ngIf="element.statusActionImplement == 'Pending'" class="fas fa-exclamation-triangle"
                  style="color:rgb(243, 160, 92); position: relative;"></i>
                <i *ngIf="element.statusActionImplement == 'In Progress'" class="fas fa-cogs"
                  style="color:rgb(24, 17, 160); position: relative;"></i>
                <i *ngIf="element.statusActionImplement == 'Not Completed'" class="fas fa-exclamation-circle"
                  style="color:rgb(245, 41, 41); position: relative;"></i>
                <i *ngIf="element.statusActionImplement == 'In Process'" class="fas fa-cog"
                  style="color:rgb(24, 17, 160); position: relative;"></i>
              </span>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="semaphore">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 3%">
        </th>
        <td mat-cell *matCellDef="let element; let i = index">

        </td>
      </ng-container>
      <ng-container matColumnDef="btnClone">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 4%"></th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div *ngIf="(rolUser.role == 'OEG' && isDataComplete) && (operationNumber.status == 'Required' || operationNumber.status == 'Observed' || operationNumber.status == 'Reject')"
            style="position: relative;top: -60px;width: 98%;left: 14%;align-content: flex-end;">
            <div *ngIf="!element.clone && rolUser.role == 'OEG'">
              <button (click)="addActionPlan(element.idAction)" matTooltip="Duplicate"
                [matTooltipPosition]="position.value">
                <i class="fas fa-plus-circle" style="color:rgb(50, 143, 10);font-size: x-large;"></i>
              </button>
            </div>
            <div *ngIf="element.clone && rolUser.role == 'OEG'">
              <button (click)="deleteActionPlan(element.idAction)" matTooltip="Delete action"
                [matTooltipPosition]="position.value">
                <i class="fas fa-minus-circle" style="color:rgb(245, 41, 41);font-size: x-large;"></i>
              </button>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="ComentsOE">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 5%">
          <ng-container>Comments OEA</ng-container>
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div>
            <ng-container>
              <label></label>
              <textarea class="textarea__area-modal--size-small textarea__area-modal--color-table"
                [(ngModel)]="element.commentsActionOE"
                [disabled]="(rolUser.role != 'OEA' && rolUser.role != 'OEG')"
                ></textarea>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="ComentsEGF">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 5%">
          <ng-container>Comments EGF</ng-container>
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div>
            <ng-container>
              <label></label>
              <textarea class="textarea__area-modal--size-small textarea__area-modal--color-table"
                [(ngModel)]="element.commentsActionEGF" 
                [disabled]="(rolUser.role != 'Admin' && rolUser.role != 'OEG')"></textarea>
            </ng-container>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="managementAP">
        <th class="th-header__th-color" mat-header-cell *matHeaderCellDef style="width: 4%"></th>
        <td mat-cell *matCellDef="let element; let i = index" [ngClass]="{'backgroung-btn-col':rolUser.role == 'OEG' }">
          <div style="position: relative;top: -60px;width: 98%;left: 14%;align-content: flex-end;"
            matTooltip="Management" [matTooltipPosition]="position.value">
            <a *ngIf="rolUser.role == 'OEG' && !isMyActionPlan" style="float: none;"
              class="bl-finding-form__color-icon btn-mcp" (click)="element.isExpanded = !element.isExpanded"
              [class.disabled]="!element.definedActions || !element.responsible || !element.verificationMeans || operationNumber.status != 'In Process'">
              <i style="font-size: x-large;    position: relative;" class="fas fa-pen"></i>
            </a>
            <a *ngIf="rolUser.role == 'OEA' ||  isMyActionPlan" style="float: none;"
              class="bl-historical-search__text btn-mcp" (click)="element.isExpanded = !element.isExpanded">
              <i style="font-size: x-large;    position: relative;" class="fas fa-search"></i>
            </a>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element; let i = index" [attr.colspan]="displayedColumns.length"
          style="height: 2px; padding: 0px;">

          <div *ngIf="element.isExpanded" class="row container-expanded"
            [@detailExpand]="element.isExpanded ? 'expanded' : 'collapsed'">
            <div class="row">
              <br>
              <h5>Action plan management</h5>
              <br>
            </div>
            <div class="row" style="background-color: white">
              <div class="row input-apm ">
                <div class="col-6">
                  <mat-form-field appearance="fill" matTooltip="Select a status" [matTooltipPosition]="position.value">
                    <mat-label>Status</mat-label>
                    <mat-select [(ngModel)]="element.status" [disabled]="rolUser.role == 'OEA' || isMyActionPlan">
                      <mat-option *ngFor="let status of listStatus" [value]="status.value"
                        [disabled]="status.value=='To implement'">
                        {{status.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field *ngIf="element.status == 'Complete'" appearance="fill">
                    <label for="">Date Implementation</label>
                    <input matInput [matDatepickerFilter]="myFilter" [matDatepicker]="picker"
                      (dateChange)=(dateChange(i,$event)) [(ngModel)]="element.dateStatusCompleted"
                      [disabled]="rolUser.role == 'OEA' || isMyActionPlan || element.status != 'Complete'"
                      [min]="minDate" [max]="maxDate" matTooltip="Date for status Complete"
                      [matTooltipPosition]="position.value" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field *ngIf="element.status == 'In progress'" appearance="fill"
                    matTooltip="Date for status In Progress" [matTooltipPosition]="position.value">
                    <label for="">Date in progress</label>
                    <input matInput [matDatepickerFilter]="myFilter" [matDatepicker]="picker"
                      [(ngModel)]="element.dateStatusInProgress" [disabled]="rolUser.role == 'OEA' || isMyActionPlan"
                      [min]="minDate" [max]="maxDate" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-12">
                <div>
                  <ng-container *ngIf="element.status == 'In progress'">
                    <label>Comment status in progress</label><br>
                    <textarea [disabled]="rolUser.role == 'OEA' || isMyActionPlan" class="comment-implementation"
                      [(ngModel)]="element.commentStatusInProgress"></textarea>
                  </ng-container>
                  <ng-container *ngIf="element.status == 'Complete'">
                    <label>Comment status Completed</label><br>
                    <textarea [disabled]="rolUser.role == 'OEA' || isMyActionPlan" class="comment-implementation"
                      [(ngModel)]="element.commentStatusCompleted"></textarea>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" style="height: 2px; padding: 0px;"></tr>
    </table>
    <div *ngIf="!operationNumber" class="select-operation">
      <label for="" class="labe-bold">Select an operation number</label>
    </div>
  </div>

  <a *ngIf="!scoreScreen" (click)="backToTop()" class="bl-anchor" style="bottom: 0.5em;">
    <div class="bl-anchor__arrow"></div>
    <div class="bl-anchor__square">Back to top</div>
  </a>
</div>